import React, {Component} from 'react';
import {Container, Row, Col, Card, CardBody, Button } from 'reactstrap';
import EnvConfig from '../../../config/env'

class Page403 extends Component {

  homepageBack = () => {
    this.props.history.push('/dashboard');
  }

  render() {
    return (
      <div className="app flex-row align-items-center bg-master ">
        <Container>
          <Row>
            <Col md="12">
            <div className="logo">
              <a href={EnvConfig.HTML_REF}>
                  <img alt="Logo" src="../img/logo.png" />
              </a>
            </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md="8">
              <Card className="p-4">
                <CardBody>
                <div className="clearfix">
                  <h1 className="float-left display-3 mr-4">403</h1>
                  <h4 className="pt-3">Truy cập trái phép!</h4>
                  <p className="text-muted float-left">
                    Bạn không có quyền truy cập chức năng trên.
                    <Button color="link" className="px-0 text-gray" onClick={this.homepageBack.bind(this)}>
                      <span className="aceess_denied_goto_homepage">về trang chủ</span></Button>
                  </p>
                </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Page403;



// WEBPACK FOOTER //
// ./src/views/Pages/Page403/Page403.js